<template>
  <Drawer
    width="400"
    :title="`${openedEntity ? '编辑' : '新增'}机构`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem
          label="机构"
          prop="name"
          style="width: 366px"
        >
          <Input
            v-model="formItem.name"
            clearable
            placeholder="请填写机构名"
          />
        </FormItem>
        <FormItem
          label="机构简称"
          prop="abbr"
          style="width: 366px"
        >
          <Input
            v-model="formItem.abbr"
            clearable
            placeholder="请填写机构简称"
          />
        </FormItem>
        <FormItem
          label="类型"
          prop="type"
          style="width: 366px"
        >
          <RadioGroup v-model="formItem.type">
            <Radio label="bank">
              <span>银行</span>
            </Radio>
            <Radio label="gov">
              <span>政府单位</span>
            </Radio>
            <Radio label="law">
              <span>律师事务所</span>
            </Radio>
            <Radio label="securities">
              <span>券商</span>
            </Radio>
            <Radio label="company">
              <span>公司（非供应商）</span>
            </Radio>
            <Radio label="others">
              <span>其他</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "EditEntityDrawer",
  data() {
    return {
      drawerOpened: false,
      formItem: {
        name: null,
        abbr: null,
        type: null,
      },
      openedEntity: null,
      ruleValidate: {
        name: [{ required: true, message: "机构为必填项", trigger: "submit" }],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      createEntity: "entity/createEntityAction",
      updateEntity: "entity/updateEntityAction",
    }),
    async openDrawer(entity) {
      this.$refs["formItem"].resetFields();
      this.openedEntity = entity; // 如果有打开，则为编辑模式
      if (entity) {
        this.formItem.name = entity.name;
        this.formItem.abbr = entity.abbr;
        this.formItem.type = entity.type;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedEntity) {
              await this.updateEntity({
                id: this.openedEntity._id,
                data: this.formItem,
              });
            } else {
              await this.createEntity(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>